module.exports = __webpack_public_path__ + "img/vertical_7_1_5010.9573756a.png";